import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';
import CrudApiClient from './crudapiclient';

class SkuAPIClient extends CrudApiClient {
  constructor(target?: string) {
    let url = GATEWAY_API_URL + '/sku';
    if (target && target !== '') url += '/' + target;
    super(url);
  }

  async search(query: any, page: number, size: number, meta: MetaQuery | undefined): Promise<any> {
    try {
      if (!query.filters || query.filters.length == 0) {
        return [];
      }
      return await super.search(query, page, size, meta);
    } catch (error) {
      console.error(`Error searching entities with Query:`, query, error);
      throw error;
    }
  }

  async deleteSkusSafely(
    _sorters: unknown,
    _filters: unknown,
    payload: { skus: Array<string>; reason: string },
    _query: unknown,
    _headers: unknown,
    _meta: MetaQuery | undefined,
  ): Promise<unknown> {
    void _query;
    void _headers;
    void _meta;
    const response = await axiosInstance.post(`${this.baseURL}/delete-safely`, payload);
    return response.data?.data;
  }
}

export default SkuAPIClient;
